import {useZero} from '@/shared/integrations/zero/use-zero'
import {AcknowledgeExpiredBatchSchema} from '@cypro/engine/mutators'
import {useCallback} from 'react'

export function useAcknowledgeExpiredBatch() {
  const zero = useZero()

  return useCallback(
    async (payload: AcknowledgeExpiredBatchSchema) =>
      await zero.attemptMutation(zero.mutators.stocks.acknowledgeExpiredBatch(payload), async ({server}) => {
        const result = await server
        return result
      }),
    [zero]
  )
}
